__turbopack_context__.v({
  "badge": "G2dZJq_badge",
});
